// src/app/store.ts
// Redux store — no redux-persist; cookies handle auth persistence.
import { configureStore } from '@reduxjs/toolkit'
import authReducer from '@/features/auth/auth.slice'
import institutionUiReducer from '@/features/institutions/institution.slice'
import staffReducer from '@/features/staff/staff.slice'
import syllabusReducer from '@/features/syllabus/syllabus.slice'
import studentUiReducer from '@/features/students/student.slice'
import examUiReducer from '@/features/exams/exam.slice'
import { baseApi } from '@/services/base.api'

export const store = configureStore({
  reducer: {
    auth:                  authReducer,
    institutionUi:         institutionUiReducer,
    staffUi:               staffReducer,
    syllabus:              syllabusReducer,
    studentUi:             studentUiReducer,
    examUi:                examUiReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
})

export type RootState   = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
